import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  ExportButton,
  Filter,
  EditButton,
  CreateButton,
  required,
} from 'react-admin';
const CodeFilter = (props) => (
  <Filter {...props}>
      <TextInput label="Нэр" source="type" alwaysOn />
  </Filter>
);

const VideoTypeActions = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    currentSort,
    total,
    exporter,
    basePath,
  } = props;

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={total}
      />
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const VideoTypeList = props => (
  <List {...props} filters={<CodeFilter/>} actions={<VideoTypeActions props={props} />}>
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <TextField label="Төрөлийн нэр" source="type" />
      <EditButton />
    </Datagrid>
  </List>
);

const VideoTypeTitle = ({ record }) => {
  const { type } = record;
  return <span>VideoType {record ? `"${type}"` : ''}</span>;
};

export const VideoTypeEdit = props => (
  <Edit title={<VideoTypeTitle />} {...props}>
    <SimpleForm>
      <TextField label="ID" source="id" />
      <TextInput label="Нэр" source="type" validate={[required()]} />
    </SimpleForm>
  </Edit>
);

export const VideoTypeCreate = props => (
  <Create {...props}>
    <SimpleForm>
        <TextField label="ID" source="id" />
      <TextInput label="Нэр" source="type" validate={[required()]} />
    </SimpleForm>
  </Create>
);